import styled from 'styled-components';

export const CodeScanner = styled.div`
  margin: auto;
  width: ${({width}) => `${width ? width : 500}px`};
`;
